import * as _encodeUtf2 from "encode-utf8";
var _encodeUtf = "default" in _encodeUtf2 ? _encodeUtf2.default : _encodeUtf2;
import _mode from "./mode";
var _global = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : global;
var exports = {};
const encodeUtf8 = _encodeUtf;
const Mode = _mode;
function ByteData(data) {
  (this || _global).mode = Mode.BYTE;
  if (typeof data === "string") {
    data = encodeUtf8(data);
  }
  (this || _global).data = new Uint8Array(data);
}
ByteData.getBitsLength = function getBitsLength(length) {
  return length * 8;
};
ByteData.prototype.getLength = function getLength() {
  return (this || _global).data.length;
};
ByteData.prototype.getBitsLength = function getBitsLength() {
  return ByteData.getBitsLength((this || _global).data.length);
};
ByteData.prototype.write = function (bitBuffer) {
  for (let i = 0, l = (this || _global).data.length; i < l; i++) {
    bitBuffer.put((this || _global).data[i], 8);
  }
};
exports = ByteData;
export default exports;